import { render, staticRenderFns } from "./EditPodcast.vue?vue&type=template&id=5c9d4d04"
import script from "./EditPodcast.vue?vue&type=script&lang=js"
export * from "./EditPodcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports